import AuthService from "./auth.service";

export default function checkAuth() {
  if (AuthService.getCurrentUser()) {
    return true;
  } else {
    return false;
  }
}
